import { RootState } from '@checkout/state';
import { SyntheticEvent } from 'react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { compose } from 'redux';
import { MembershipForms } from '..';
import { toggleMembershipOverlay } from '../../../reducers/checkout';
import messages from './../../../i18n/base-en';
import { Button } from './../../presentational';
import * as Styles from './MembershipOverlayPopup.scss';

interface IOwnProps {}

interface IConnectedProps {
  isOpen: boolean;
}

interface IConnectetDispatchProps {
  toggleMembershipOverlay: typeof toggleMembershipOverlay;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class MembershipOverlayPopup extends React.Component<Props, {}> {

  handleClose = (event: SyntheticEvent<HTMLButtonElement> | React.MouseEvent<HTMLElement>) => {
    const { toggleMembershipOverlay: toggleOverlay } = this.props;
    toggleOverlay({ isOpen: false });
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  render() {
    const { isOpen, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <TransitionGroup>
        {isOpen && (
          <CSSTransition classNames="fade" timeout={{ enter: 600, exit: 350 }}>
            <div className={Styles.overlay}>
              <div className={Styles.background} onClick={this.handleClose} />
              <div className={Styles.content}>
                <MembershipForms />
                <div className={Styles.close}>
                  <Button
                    onClick={this.handleClose}
                    type="button"
                    variant="clear"
                    align="center"
                    size="medium"
                    label={formatMessage(messages.membership_close_overlay)}
                  />
                </div>
              </div>
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isOpen: state.checkout.ui.membership.overlay.isOpen,
    }),
    {
      toggleMembershipOverlay
    }
  )
)(MembershipOverlayPopup);
